import axios from 'axios'
import qs from 'qs'
import ls from 'store2'
import { Message } from 'view-design'
import pubfunction from '@/util/comfunction'
import xss from '@/util/xss'
import Base64 from '@/util/encryptlong'
import { getCurToken } from '@/util/index.js'

const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8', //'application/x-www-form-urlencoded; charset=UTF-8',
    'Content-Disposition': 'inline',
    // "Origin":"uat.nonprd-ocm.mobil.com.cn"
    // "Access-Control-Allow-Origin:":window.location.origin
    // "Access-Control-Allow-Origin": "uat.nonprd-ocm.mobil.com.cn",

}

let baseConfig = {
    headers,
    timeout: 1000 * 30,
    withCredentials: true
}
let gqdmo = 0

function doSucc(res) {

    if (res.data.code == -9999) {
        if (gqdmo == 0) {
            const userRole = ls.get('userRole') || ""
            Message.error('您的账号已在其他地方登录')
            setTimeout(() => {

                if (userRole.indexOf('m') > -1) window.location.href = '/admin/login'
                else window.location.href = '/customer/login'
                ls.clearAll();
                return {}

            }, 3000)

        }
        gqdmo = gqdmo + 1


    } else if (res && (res.status === 200 || res.status === 304 || res.status == 400)) {

        res.data.data = recursion(res.data.data)

        return res.data
        return
    } else {
        Message.error(data.error)
        return {}
    }
}
const recursion = (data) => {
    let tyoe = typeof data
    if (tyoe == "object" && !(Array.isArray(data))) {
        for (let key in data) {
            let item = data[key]
            if (item) {
                if (typeof item == "string") {
                    data[key] = xss.process(item)
                } else if (Array.isArray(item)) {
                    data[key] = item.map((eitem) => {
                        if (eitem) {
                            eitem = recursion(eitem)
                        }
                        return eitem
                    })
                }
            }

        }
    } else if (tyoe == "string") {
        if (data) {
            data = xss.process(data)
        }

    } else if (Array.isArray(data)) {
        data = data.map((eitem) => {
            if (eitem) {
                eitem = recursion(eitem)
            }
            return eitem
        })
    }
    return data
}
function doError(err, url = "") {
    const userRole = ls.get('userRole') || ""

    const errInfo = err.response

    if (errInfo) {
        const { status, statusText, message, data } = err.response
        console.log('err.response',data.msg)
        // token过期不给提示!
        let code=data.code
        if ((status === 401||status === 403)||(code === "A0230"||code === "A0231")) { // data.code === "A0201"
            ls.clearAll();
            const querurl = pubfunction.parseQueryParams()
            if (querurl.path == "/business/lookdiaticreport") {
                ls.set("paraquery", pubfunction.parseQueryParams())
            }

            if (userRole.indexOf('m') > -1) window.location.href = '/admin/login'
            else window.location.href = '/customer/login'
            return {}
        } else {

            if (errInfo.config.url.includes("oil-site/detailIsShow")) {
                Message.error("暂无权限")
                return err
            } else if (url === '/ocm-admin/messageCenter/messageCenterList') {
                return err;
            } else {
               Message.error(data.msg || statusText)
                return err
                //  }

            }
        }
    } else {

        if (!url.includes("diagnostic-report/edit/up")) {
            Message.error('服务器连接失败')
        }

    }
}

// 

const config = {}
if (process.env.NODE_ENV == 'development') config.api = '/ocm/api'
else config.api = '/api'

export default {
    axs(method, url, data = {}) {

        return axios({
            ...baseConfig,
            method: method,
            url: config.api + url,
            // params: data,
            data: qs.stringify(data),
            // data: bodyData
        })
            .then(doSucc)
            .catch(doError)
    },
    axsl(method, url, data = {}, bodyData = {}) {

        //baseConfig.headers.Authorization = 'Basic b2NtOkZWdlh0QktQeWJmN3I2TTNwZ0g3YVdMTzB0a0ZMYnNv' //正常的
        //  baseConfig.headers.Authorization = 'Basic b2NtX3Rlc3Q6RlZ2WHRCS1B5YmY3cjZNM3BnSDdhV0xPMHRrRkxic28=' 
        let baseConfig1 = JSON.parse(JSON.stringify(baseConfig))
        console.log('baseConfig1', baseConfig1)
        if (baseConfig1.headers && (baseConfig1.headers.Authorization || baseConfig1.headers.Authorization == false)) {
            baseConfig1.headers.Authorization = undefined
            delete baseConfig1.headers.Authorization
        }
        console.log('baseConfig1', baseConfig1)
        return axios({
            ...baseConfig1,
            method: method,
            url: config.api + url,
            params: data,
            data: bodyData
        })
            .then(doSucc)
            .catch(doError)
    },
    axss(method, url, bodyData = {}, data = {},) {

        baseConfig.headers.Authorization = getCurToken()

        //  baseConfig={...baseConfig,...perconfig}

        if (method == "post") {
            for (let key in bodyData) {
                let item = bodyData[key]
                if (typeof item == "string") {
                    bodyData[key] = xss.process(item)
                }


            }
        }

        return axios({

            ...baseConfig,
            method: method,
            url: config.api + url,
            data: bodyData,
            params: data
        })
            .then(doSucc)
            .catch((e) => {
                doError(e, url)
            })
    },
    arrbuff(method, url, bodyData = {}, data = {},) {//导出专用
        baseConfig.headers.Authorization = getCurToken()
        baseConfig.responseType = "arraybuffer"
        //  baseConfig={...baseConfig,...perconfig}
        return axios({

            ...baseConfig,
            method: method,
            url: config.api + url,
            data: bodyData,
            params: data
        })
            .then(doSucc)
            .catch(doError)
    },
    axsUserInfo(method, url, token = { token_type: '', access_token: '', }) {
        baseConfig.headers.Authorization = token.token_type + ' ' + token.access_token
        return axios({
            ...baseConfig,
            method: method,
            url: config.api + url,
        })
            .then(doSucc)
            .catch(doError)
    },
    asxUpFile(method, url, datas = {}) {
        return axios({
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": getCurToken()
            },
            method: method,
            url: config.api + url,
            data: datas
        })
            .then(doSucc)
            .catch(doError)
    }
}